import { useState, MouseEvent, CSSProperties, ReactNode } from "react";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";

type ButtonsProps = {
  label: ReactNode | string;
  width?: string;
  height?: string;
  color?: string;
  border?: any;
  cursor?: string;
  backgroundColor?: string;
  borderLine?: string;
  textColor?: string;
  borderRadius?: string;
  handleClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  smallScreenStyle?: string;
  style?: CSSProperties;
  type?: string;
};

const Buttons = (props: ButtonsProps) => {
  const [color, setColor] = useState("");

  const buttonStyle = {
    width: props.width || "auto",
    height: props.height || "auto",
    backgroundColor: props.disabled
      ? `${colors.ButtonBackgroundColors.primaryDisabledButton}`
      : props.color || color,
    color: props.textColor ? props.textColor : colors.White,
    border: props.borderLine ? props.borderLine : "none",
    borderRadius: props.border || "8px",
    cursor: "pointer",
    display: "flex",
    fontSize: `${fipayFonts.fipayFonts.fontSize.body2}`,
    fontWeight: `${fipayFonts.fipayFonts.fontWeight.medium}`,
    justifyContent: "space-evenly",
    alignItems: "center",
    fontFamily: "GT Walsheim Pro",
    type: "button" || "submit" || "reset",
  };

  const buttonStyleMediumScreen = {
    width: props.label === "Sign in" ? "100%" : "90%",
    height: "43px",
    backgroundColor: `${colors.ButtonBackgroundColors.primaryMediumHoverButton}`,
    cursor: "pointer",
    borderRadius: "35px",
    border: "none",
    color: "white",
  };

  const buttonStyleSmallScreen = {
    width: props.label === "Sign in" ? "100%" : "90%",
    height: "43px",
    backgroundColor: `${colors.ButtonBackgroundColors.primaryMediumHoverButton}`,
    cursor: "pointer",
    borderRadius: "35px",
    border: "none",
    color: "white",
    ...(props.style || {}),
  };

  const buttonStyleSmallestScreen = {
    width: "90%",
    height: "33px",
    backgroundColor: `${colors.ButtonBackgroundColors.primaryMediumHoverButton}`,
    cursor: "pointer",
    borderRadius: "35px",
    border: "none",
    color: "white",
    ...(props.style || {}),
  };

  return (
    <button
      onClick={props.handleClick}
      disabled={props.disabled}
      style={
        props.smallScreenStyle
          ? buttonStyleSmallScreen
          : window.innerWidth <= 280
            ? buttonStyleSmallestScreen
            : window.innerWidth <= 480
              ? buttonStyleSmallScreen
              : window.innerWidth <= 540
                ? buttonStyleMediumScreen
                : buttonStyle
      }
    >
      {props.label}
    </button>
  );
};

export default Buttons;
